// SPDX-License-Identifier: AGPL-3.0-or-later

import {Routes} from '@app/app/Routes';

const GUILD_ROOT_PATH_SEGMENT_COUNT = 3;

export interface MobileBottomNavVisibilityQuery {
	readonly mobileLayoutEnabled: boolean;
	readonly pathname: string;
}

export interface AppLoadingSkeletonVisibilityQuery {
	readonly booting: boolean;
	readonly isAuthenticated: boolean;
	readonly isAuthSessionInitialized: boolean;
	readonly shouldBypassGateway: boolean;
}

const BOTTOM_NAV_ROOT_ROUTES = new Set<string>([Routes.ME, Routes.FAVORITES, Routes.NOTIFICATIONS, Routes.YOU]);

export function shouldShowMobileBottomNav({mobileLayoutEnabled, pathname}: MobileBottomNavVisibilityQuery): boolean {
	if (!mobileLayoutEnabled) {
		return false;
	}
	if (BOTTOM_NAV_ROOT_ROUTES.has(pathname)) {
		return true;
	}
	// Pioneerchat: To-dos is one of the four phone tabs, so the tab bar stays.
	if (/^\/channels\/\d+\/tasks$/.test(pathname)) {
		return true;
	}
	if (/^\/channels\/@me\/\d+$/.test(pathname)) {
		return true;
	}
	if (!Routes.isGuildChannelRoute(pathname)) {
		return false;
	}
	// Pioneerchat keeps the tab bar inside chats too, as in the design.
	return isGuildRootRoute(pathname) || pathname.split('/').length === GUILD_ROOT_PATH_SEGMENT_COUNT + 1;
}

export function shouldShowLoadingSkeleton({
	booting,
	isAuthenticated,
	isAuthSessionInitialized,
	shouldBypassGateway,
}: AppLoadingSkeletonVisibilityQuery): boolean {
	if (shouldBypassGateway) {
		return false;
	}
	if (!isAuthenticated) {
		return false;
	}
	if (!isAuthSessionInitialized) {
		return true;
	}
	return booting;
}

function isGuildRootRoute(pathname: string): boolean {
	return pathname.split('/').length === GUILD_ROOT_PATH_SEGMENT_COUNT;
}
